import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-sm fixed-top navbar-dark bg-primary text-white" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = {
  id: "navbarSupportedContent",
  class: "collapse navbar-collapse"
}
const _hoisted_5 = { class: "navbar-nav me-auto mb-0 mb-lg-0" }
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  id: "dashboardNavbarDropdown",
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Dashboards ", -1)
const _hoisted_8 = {
  class: "dropdown-menu",
  "aria-labelledby": "dashboardNavbarDropdown"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Orders ")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Productivity ")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Agency ")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Orders ")
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Customers ")
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Order Items ")
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" View builder ")
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Special reports ")
const _hoisted_25 = { class: "nav-item dropdown" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Shopify ", -1)
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Shopify Templates ")
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Shopify order recovery ")
const _hoisted_32 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  id: "navbarDropdown",
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Super Admin ", -1)
const _hoisted_34 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" DeliveryConfig ")
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Analytics ")
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Showcase ")
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Refund/Redo types ")
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" CH Admin Management ")
const _hoisted_45 = { class: "nav-item" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Grid Filter Categories Managment ")
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Flags ")
const _hoisted_49 = { class: "nav-item" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Average Spend Category Managment ")
const _hoisted_51 = { class: "nav-item" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" State Management ")
const _hoisted_53 = { class: "nav-item" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Promotional Codes ")
const _hoisted_55 = { class: "nav-item" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Production branch routing ")
const _hoisted_57 = { class: "nav-item" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Dashboard settings ")
const _hoisted_59 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Commissions ", -1)
const _hoisted_61 = { class: "dropdown-menu" }
const _hoisted_62 = { class: "nav-item" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Sales reps ")
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Account handlers ")
const _hoisted_66 = { class: "nav-item dropdown" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("a", {
  id: "productionNavbarDropdown",
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, "Production", -1)
const _hoisted_68 = {
  class: "dropdown-menu",
  "aria-labelledby": "productionNavbarDropdown"
}
const _hoisted_69 = { class: "nav-item" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Team ")
const _hoisted_71 = { class: "nav-item" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Team Schedule ")
const _hoisted_73 = { class: "nav-item" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Adjustments ")
const _hoisted_75 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "https://app.creativehub.io/UsersAdmin",
    target: "_blank"
  }, " Impersonate ")
], -1)
const _hoisted_76 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/dashboard"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/order-productivity-dashboard"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/agencies-dashboard"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/orders"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/customers"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/orders-items"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/grid-filters-list"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/special-report-list"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("ul", _hoisted_27, [
                _createElementVNode("li", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/shopify/template"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_30, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/shopify/orders-recovery"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_ctx.superAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("ul", _hoisted_34, [
                    _createElementVNode("li", _hoisted_35, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/delivery/config"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_37, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/analytics"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_39, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/cn-showcase"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_41, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/refund-types"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_43, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/ch-admin-management"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_45, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/grid-filter-categories"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_47, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/for-invoicing-managment"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_49, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/average-spend-category-managment"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_50
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_51, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/order-state-manager"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_52
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_53, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/promotional-codes"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_55, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/printing-rules"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_56
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_57, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/dashboard-settings"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_58
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasCommissionsMenu)
              ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("ul", _hoisted_61, [
                    _createElementVNode("li", _hoisted_62, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/commissions/sales-reps"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_63
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_64, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/commissions/account-handlers"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_65
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("ul", _hoisted_68, [
                _createElementVNode("li", _hoisted_69, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/production-team-admin"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_70
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_71, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/production-teams"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_73, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/adjustments"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_74
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_75
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}